<template>
  <section class="section-offers-and-promotions" v-if="!isLoadingPromotions">
    <div class="container">
      <div class="section-space-25"></div>
      <div class="section-header-title mb-0">Offers and Promotions</div>
      <div class="section-space-25"></div>
      <div class="row offersAndPromotionsBox">
        <div class="col-md-8">
          <p>
            Well, who doesn’t like that something ‘extra’; we do for sure! Keep
            an eye on this page and get your hands on some exciting offers from
            the house of Miraj!
          </p>
        </div>
        <!-- v-b-modal.alertPopup -->
        <template>
          <div
            class="col-md-6 mb-3"
            v-for="(PromotionItems, PromotionIndex) in promotions"
            :key="PromotionIndex + '_Promos'"
          >
            <div class="row mx-0 shadow rounded bg-dark-2">
              <div class="col-md-4 px-0 pr-md-3">
                <img
                  v-lazy="IMAGE_URL + PromotionItems.image_path"
                  class="place-img"
                  alt=""
                />
                <!-- @/assets/img/placeHolder.png -->
              </div>
              <div class="col-md-8 py-3">
                <div class="text-right mb-3">
                  <img :src="IMAGE_URL + PromotionItems.promo_partner" alt="" />
                  <!-- @/assets/img/Axis_Bank_logo_logotype 1.png -->
                </div>
                <h4 class="add-title">{{ PromotionItems.promo_title }}</h4>
                <p class="add-text">
                  {{ PromotionItems.promo_description }}
                </p>
                <p class="add-small-txt">
                  Valid till {{ PromotionItems.promo_expiry | dateparse }}
                </p>
                <p class="tnc-txt">{{ PromotionItems.promo_required || "" }}</p>
              </div>
            </div>
          </div>
        </template>
        <!-- <div class="col-md-6 mb-3">
          <img
            src="@/assets/img/promoTest/Promocard-2.png"
            class="img-fluid"
            alt="offer Image"
          />
        </div>
        <div class="col-md-6 mb-3">
          <img
            src="@/assets/img/promoTest/Promocard-3.png"
            class="img-fluid"
            alt="offer Image"
          />
        </div>
        <div class="col-md-6 mb-3">
          <img
            src="@/assets/img/promoTest/Promocard-4.png"
            class="img-fluid"
            alt="offer Image"
          />
        </div>
        <div class="col-md-6 mb-3">
          <img
            src="@/assets/img/promoTest/Promocard-5.png"
            class="img-fluid"
            alt="offer Image"
          />
        </div> -->
      </div>
      <!-- <button class="btn btn-primary mt-4 px-5" v-b-modal.alertPopup>SUBMIT</button> -->

      <div class="section-space-50"></div>

      <!-- PROMOS & OFFERS - POP UP -->
      <b-modal id="alertPopup" title="Buy one Get One" hide-footer>
        <div class="px-2 px-md-3 mt-2 offersAndPromotions">
          <img
            src="@/assets/img/promoTest/Promocard-2.png"
            class="img-fluid rounded"
            alt
          />
          <div class="row pb-3 border-bottom border-dark mx-0 my-2">
            <div class="col-md-8 offerText">
              On Select Movies in Select cinemas. Hurry! Available for Limited
              Tickets.
            </div>
            <div class="col-md-4 text-right text-md-left">
              <p class="mb-0 text-rose-gold fs-14 text-left text-md-right">
                Offer valid till:
              </p>
              <p class="mb-0 offerText text-left text-md-right">
                March 31, 2020
              </p>
            </div>
          </div>
          <p class="font-weight-bold">T&amp;C:</p>
          <ul class="pl-4">
            <li>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel
              velit eros. Cras eget urna molestie.
            </li>
            <li>
              Suspendisse justo enim, congue ut metus sit amet, lacinia amet,
              consect ultrices ex.
            </li>
            <li>
              Ut eu enim ut ligula hendrerit hendrerit. Sed lacinia metus id
              accumsan amet, consect maximus. Cras ege.
            </li>
            <li>
              Vestibulum nec pellentesque metus. Curabitur quis fringilla.
            </li>
          </ul>
        </div>
        <div class="rainbow-line">
          <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
        </div>
      </b-modal>
    </div>
  </section>
</template>
<script>
import Vue from "vue";
import { mapState, mapGetters, mapActions } from "vuex";

import { IMAGEURL } from "@/config";

import MovieService from "@/apiServices/MovieService";
import PromosandOffersService from "@/apiServices/PromosandOffersService";

export default {
  props: {},
  data() {
    return {
      IMAGE_URL: IMAGEURL,

      isLoadingPromotions: false,
      promotions: []
    };
  },
  computed: {},
  beforeMount() {
    this.getPromotionsAndOffers();
  },
  methods: {
    getPromotionsAndOffers() {
      this.isLoadingPromotions = true;

      PromosandOffersService.GetPromosAndOffers({})
        .then(response => {
          const { data } = response;
          console.log("data", data);
          if (data && data.status) {
            if (data["data"] && data.data.length) {
              this.promotions = data.data;
            }
          } else {
          }
        })
        .catch(error => {
          // PLEASE SHOW POP UP HERE IF GOT FAILED
        })
        .finally(() => {
          setTimeout(() => (this.isLoadingPromotions = false), 500);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/offersAndPromotions.vue